import {FC} from "react";
import {Card, Table} from "react-bootstrap";
import { KPIindicator } from "@oldDashboard/legacyModels/KPIindicator.model";
import { kpiConfig } from "@oldDashboard/legacyUtils";

interface LaunchKPIProps {indicator:KPIindicator}
const LaunchKPI: FC<LaunchKPIProps> = ({indicator}) => {
    if(!indicator) return null;
    const {color, realHeader, icon} = kpiConfig(indicator.header);
    return (
        <Card className="mx-1 mb-2" style={{minWidth: 330}}>
            <Card.Header className="p-2">
                <div className="px-2">
                    <span className="fw-semibold">{realHeader}</span>
                </div>
            </Card.Header>
            <Card.Body className="p-0">
                <Table className="overflow-hidden text-nowrap " style={{tableLayout:"fixed"}}>
                    <tbody>
                        <tr>
                            <th>
                                <div className="d-flex align-items-start pt-3 pb-0" style={{minHeight: 100}}>
                                    <div className="me-2 pt-2 px-1">
                                        <span className={`avatar ${color}`} style={{height:50, width:50}}>
                                            <i className={`fs-22 bi ${icon}`}/>
                                        </span>
                                    </div>
                                    <div className="d-flex flex-column flex-wrap align-items-start">
                                        <span className="fw-semibold py-0 fs-26">{indicator.value}</span>
                                        <span className="fw-normal text-wrap">{indicator.label}</span>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};

export default LaunchKPI;
